module.exports = __webpack_public_path__ + "static/media/intra_destination_transfer.5c4d7931.svg";